const angular = require('angular')
// 消息控件
// usage: $message.push(...); 支持info，error，success, warning 等类型

angular.module('ui.hxphone.message', [])

  .directive('message', ['$document', '$transition', '$timeout',
    function ($document, $transition, $timeout) {
      return {
        restrict: 'EA',
        template: require('views/components/message.html'),
        transclude: true,
        replace: true,
        link: function (scope, element) {
          scope.style = {
            opacity: 0
          }

          // 宽度和left位移是固定的
          // let elementWidth = element[0].clientWidth,
          const body = $document.find('body').eq(0)
          const bodyWidth = body[0].clientWidth
          const footerHeight = 46 // 页脚的高度
          const elementLeft = 22
          const elementWidth = bodyWidth - 2 * elementLeft

          element.css({
            left: elementLeft + 'px',
            width: elementWidth + 'px'
          })

          // trigger CSS transitions
          $timeout(function () {
            // 由于之前调整了div的宽度，因此需要等待动画触发Dom刷新后再调整top位移
            const elementHeight = element[0].clientHeight
            const bodyHeight = body[0].clientHeight
            const elementTop = bodyHeight - elementHeight - footerHeight - 10

            element.css({
              top: elementTop + 'px'
            })
            scope.style = {
              opacity: 1
            }
          })
        }
      }
    }])

  .provider('$message', function() {
    const supportedTypes = [
      'info', 'error', 'success', 'warning'
    ]

    function checkSupportedTypes (type) {
      let supported = false
      angular.forEach(supportedTypes, function(value, key) {
        if (value == type) {
          supported = true
          return false
        }
        return true
      })
      return supported
    }

    return {
      $get: ['$transition', '$timeout', '$document', '$compile', '$rootScope', '$$uiHelpers',
        function ($transition, $timeout, $document, $compile, $rootScope, $$uiHelpers) {
          const $message = {}
          let messageScope, messageDomEl
          const messageStore = []
          let isShowing = false // 保证每次只有一条message在显示
          const body = $document.find('body').eq(0)

          function showMessage() {
            isShowing = true
            const messageForShow = messageStore.shift()
            messageScope = $rootScope.$new(true)
            messageScope.type = messageForShow.type
            messageScope.message = messageForShow.message
            messageDomEl = $compile('<div message></div>')(messageScope)
            body.append(messageDomEl)
            // 持续显示duration长度的时间
            $timeout(dismissMessage, messageForShow.duration)
          }

          function dismissMessage() {
            let messageScopeRef = messageScope
            messageScope.style = {
              opacity: 0
            }
            messageScope.$apply()
            $$uiHelpers.removeAfterAnimate(messageDomEl, messageScope, 400, function () {
              messageScopeRef.$destroy()
              messageScopeRef = null
              isShowing = false
              if (messageStore.length != 0) {
                showMessage()
              }
            })
            messageDomEl = undefined
            messageScope = undefined
          }

          /**
           * 将提示信息压入队列中等待显示
           * @param message 提示字符串
           * @param type 提示类型
           * @param duration 显示时间（毫秒） 默认3s
           */
          $message.push = function (message, type, duration) {
            // 判断是否合法类型；
            if (!checkSupportedTypes(type)) {
              throw new Error('Unsupported message type [' + type + ']')
            }
            messageStore.push({
              message: message || '',
              type: type || 'info',
              duration: duration || 3000
            })
            if (!isShowing) {
              showMessage()
            }
            return true
          }
          return $message
        }]
    }
  })



// WEBPACK FOOTER //
// ./src/js/infrastructure/message.js